import type { TouchableOpacityProps } from "react-native"

import React from "react"
import { StyleSheet, TouchableOpacity } from "react-native"
import { useStyle } from "react-native-style-utilities"
import { Theme } from "./theme"

const styles = StyleSheet.create({
  root: {
    alignItems: "center",
    backgroundColor: Theme.COLORS.$overlay,
    flex: 1,
    justifyContent: "center",
  },
})

/**
 * A component that displays a full-screen overlay.
 *
 * TODO: Touchable opacity is deprecated. Use Pressable instead.
 */
export function Overlay({ style, ...rest }: TouchableOpacityProps) {
  return (
    <TouchableOpacity
      activeOpacity={1}
      id={"overlay"}
      style={useStyle(() => [styles.root, style], [style])}
      {...rest}
    />
  )
}
